import styled from "styled-components";

export const BarraFiltroInputEditarContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;
export const BarraFiltroInputEditarHeader = styled.div`
  span {
    color: var(--color-white);
    font-size: 16px;
    font-weight: 700;
  }
`;
export const BarraFiltroInputEditarBody = styled.div`
  display: flex;
  gap: 8px;
`;
export const BarraFiltroIcon = styled.div`
  padding-right: 6px;
`;
export const BarraFiltroInputSimulado = styled.div`
  display: flex;
  padding-left: 8px;
  align-items: center;
  width: 172px;
  height: 36px;
  border-radius: 4px;
  background-color: var(--color-white);
  color: #023755;
  overflow: hidden;
  span {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;

export const BarraFiltrosBtnEditar = styled.div`
  width: 100px;
  height: 36px;
  border-radius: 8px;
  background-color: var(--color-primary);
  color: var(--color-white);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`;
